import { axiosService } from 'shared/helpers/axios';

// Project management API (kanban boards, lists and hierarchical tasks) for a
// proposal or publication. Functions throw on failure; callers show the error.

const unwrap = (res) => res.data?.results ?? res.data;

export const errorMessage = (err, fallback = 'Something went wrong') => {
  const data = err?.response?.data;
  if (!data) return err?.message || fallback;
  if (typeof data === 'string') return data;
  if (data.error) return data.error;
  if (data.detail) return data.detail;
  const first = Object.values(data)[0];
  return Array.isArray(first) ? first[0] : (typeof first === 'string' ? first : fallback);
};

// Boards
export const fetchBoards = async (proposalId) =>
  unwrap(await axiosService.get('/proposal/pm-boards/', { params: { proposal: proposalId } }));

export const createBoard = async (data) =>
  (await axiosService.post('/proposal/pm-boards/', data)).data;

export const updateBoard = async (id, data) =>
  (await axiosService.patch(`/proposal/pm-boards/${id}/`, data)).data;

export const deleteBoard = async (id) =>
  axiosService.delete(`/proposal/pm-boards/${id}/`);

// Lists (board columns)
export const createList = async (data) =>
  (await axiosService.post('/proposal/pm-lists/', data)).data;

export const updateList = async (id, data) =>
  (await axiosService.patch(`/proposal/pm-lists/${id}/`, data)).data;

export const deleteList = async (id, moveTo) =>
  axiosService.delete(`/proposal/pm-lists/${id}/`, { params: moveTo ? { move_to: moveTo } : {} });

export const reorderLists = async (boardId, listIds) =>
  axiosService.post('/proposal/pm-lists/reorder/', { board: boardId, list_ids: listIds });

// Tasks
export const fetchBoardTasks = async (boardId) =>
  unwrap(await axiosService.get('/proposal/pm-tasks/', { params: { board: boardId } }));

export const createBoardTask = async (data) =>
  (await axiosService.post('/proposal/pm-tasks/', data)).data;

export const updateBoardTask = async (id, data) =>
  (await axiosService.patch(`/proposal/pm-tasks/${id}/`, data)).data;

export const deleteBoardTask = async (id) =>
  axiosService.delete(`/proposal/pm-tasks/${id}/`);

// Full ordered contents of a list after a kanban drop
export const reorderBoardTasks = async (listId, taskIds) =>
  axiosService.post('/proposal/pm-tasks/reorder/', { board_list: listId, task_ids: taskIds });
